module.exports = __webpack_public_path__ + "72c0b5369db1914d0dee8bf5e2448c6b.png";